<template>
  <div class="cdwritemenu between">
    <div class="rightmenu">
      <div class="dxmutit">选择代写合同类型</div>
      <div class="melist">
        <div class="meiten flex_start" v-for="item in 5" :key="item">
          <div class="iticon">
            <img src="../../../assets/contmodeldet/dxmenuicon1.png" alt="" />
          </div>
          <div class="ittext">婚姻家庭</div>
          <div><svg-icon class="itic" icon-class="jt_right" /></div>

          <div class="mecont">
            <div class="meconttitle">
              婚姻家庭 <span>专业合规，降低90%常见风险的专业合同</span>
            </div>
            <div class="meclis between wrap">
              <div class="mecite" v-for="(ite, ind) in 6" :key="ind" @click="tojump(ite)">
                <div class="itctop" :class="'icp_bg' + ind">
                  <div class="icp1">代写服务</div>
                  <div class="icp2">离婚协议书</div>
                </div>
                <div class="icpri">¥149.0</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner">
      <img src="../../../assets/contmodeldet/htdxbanner_sample.png" alt="" />
    </div>
    <div class="online_adv">
      <div class="onlin">
        <img src="../../../assets/contmodeldet/htdxzxlaw.png" class="" />
        <div class="zxbtn">快速咨询</div>
      </div>
      <div class="htsh mt30">
        <img src="../../../assets/jpcol/htsh.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    tojump(){
      this.$router.push({
        name:'conmodporder'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.cdwritemenu {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .rightmenu {
    height: 434px;
    width: 208px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    position: relative;
    .dxmutit {
      width: 100%;
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-size: 20px;
      color: #fff;
      background-image: url("~assets/contmodeldet/dxmenu_bg.png");
    }
    .melist {
      .meiten {
        padding: 30px 23px 0;
        cursor: pointer;
        .iticon {
          margin-right: 13px;
          img {
            width: 38px;
          }
        }
        .ittext {
          width: 100px;
          color: #333;
        }
        .itic {
          display: none;
          font-size: 14px;
          color: #999;
          margin-top: 3px;
        }

        .mecont {
          display: none;
          position: absolute;
          top: 0;
          left: 100%;
          width: 654px;
          height: 434px;
          border-left: 24px solid #f8f8f8;
          background: #fff;
          padding: 30px 22px;
          .meconttitle {
            font-size: 20px;
            color: #333333;
            line-height: 20px;
            span {
              font-size: 14px;
              color: #999999;
              margin-left: 10px;
            }
          }
          .meclis {
            .mecite {
              width: 180px;
              margin-top: 30px;
              .itctop {
                width: 100%;
                height: 80px;
                padding: 14px 15px;
                border-radius: 4px;
                .icp1 {
                  font-size: 12px;
                  color: #666666;
                  line-height: 12px;
                }
                .icp2 {
                  margin-top: 8px;
                  font-size: 18px;
                  color: #333333;
                  line-height: 18px;
                }
              }
              .icpri {
                margin-top: 12px;
                font-size: 16px;
                color: #e22828;
                line-height: 16px;
              }
              .icp_bg0 {
                background: #f5e2e2;
              }
              .icp_bg1 {
                background: #efe4f1;
              }
              .icp_bg2 {
                background: #e8eeff;
              }
              .icp_bg3 {
                background: #e4edec;
              }
              .icp_bg4 {
                background: #f4eddf;
              }
              .icp_bg5 {
                background: #e4e7f1;
              }
            }
          }
        }
        &:hover {
          .ittext {
            color: #0465ea;
          }
          .itic {
            display: block;
          }
          .mecont {
            display: block;
          }
        }
      }
    }
  }
  .banner {
    width: 630px;
    height: 434px;
  }
  .online_adv {
    width: 314px;
    height: 434px;
    .onlin {
      position: relative;
      width: 314px;
      height: 215px;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .zxbtn {
        cursor: pointer;
        position: relative;
        z-index: 1;
        top: 130px;
        width: 156px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 0 auto;
        background: #f25618;
        border-radius: 30px;
        font-size: 22px;
        color: #ffffff;
      }
    }
    .htsh {
      width: 314px;
      height: 190px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>